import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { formatApiError } from "../../lib/api";
import { useSEO } from "../../lib/useSEO";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  useSEO("Owner Login", "Queen Denae owner login.");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5 pt-20" data-testid="admin-login-page">
      <div className="w-full max-w-md border border-gold/20 bg-gallery p-8 sm:p-12">
        <p className="font-mono text-[10px] tracking-[0.35em] uppercase text-gold/70 text-center">Owner Access</p>
        <h1 className="mt-3 font-serif text-3xl text-cream text-center tracking-tight">The Royal Office</h1>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <input
            type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            placeholder="Email" aria-label="Admin email" data-testid="admin-email-input"
            className="w-full h-13 py-4 px-5 bg-obsidian border border-gold/20 text-cream text-sm outline-none focus:border-gold placeholder:text-sand/40"
          />
          <input
            type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            placeholder="Password" aria-label="Admin password" data-testid="admin-password-input"
            className="w-full h-13 py-4 px-5 bg-obsidian border border-gold/20 text-cream text-sm outline-none focus:border-gold placeholder:text-sand/40"
          />
          {error && <p data-testid="admin-login-error" className="text-sm text-wineaccent">{error}</p>}
          <button
            type="submit" disabled={busy} data-testid="admin-login-btn"
            className="w-full h-13 py-4 bg-gold text-obsidian font-mono text-[11px] tracking-[0.3em] uppercase hover:bg-goldglow transition-colors disabled:opacity-60"
          >
            {busy ? "Unlocking…" : "Enter"}
          </button>
        </form>
        <Link to="/" className="mt-6 block text-center font-mono text-[10px] tracking-[0.3em] uppercase text-sand/50 hover:text-gold transition-colors">
          ← Back to the site
        </Link>
      </div>
    </div>
  );
}
